import React, { useRef } from "react";
import styles from "./ComingSoon.module.css";
import { usePlausible } from "../../hooks/usePlausible";
import { createEventProps, CATEGORIES } from "../../utils/analytics";
import { GlassButton } from "../CtaButton/GlassButton";
import { withAssetPath } from "../../utils/basePath";

interface ComingSoonProps {}

const ComingSoon: React.FC<ComingSoonProps> = () => {
  const logoVideoRef = useRef<HTMLVideoElement>(null);
  const backgroundVideoRef = useRef<HTMLVideoElement>(null);
  const trackEvent = usePlausible();

  return (
    <div className={styles.comingSoon}>
      {/* Fullscreen Background Video */}
      <div className={styles.backgroundVideo}>
        <video
          ref={backgroundVideoRef}
          className={styles.headphonesVideo}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
        >
          <source src={withAssetPath("/assets/video/headphones.mp4")} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className={styles.videoOverlay} />
      </div>

      {/* Foreground Content */}
      <div className={styles.content}>
        {/* Centered Logo Video */}
        <div className={styles.logoContainer}>
          <video
            ref={logoVideoRef}
            className={styles.logoVideo}
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
          >
            <source src={withAssetPath("/assets/video/little-logo_5.webm")} type="video/webm" />
            <source src={withAssetPath("/assets/video/little-logo.mp4")} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        {/* Signup Form */}
        <div className={styles.signupSection}>
          <h2 className={styles.signupTitle}>Sign up for our waitlist</h2>
          <p className={styles.signupDescription}>
            Be the first to know when we launch something amazing
          </p>
          <div className={styles.ctaContainer}>
            <GlassButton
              href="https://tally.so/r/n04EJB"
              buttonType="primary"
              className={styles.signupButton}
              onClick={() => {
                // Track the signup button click
                trackEvent(
                  "Waitlist Signup",
                  createEventProps(
                    CATEGORIES.NAV,
                    "signup-button-click",
                    "coming-soon-page"
                  )
                );
              }}
            >
              Sign Up
            </GlassButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
